// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3cMrW","title":"InfoRow_title__2rY6A"};